const DIRECTION_HORIZONTAL = 'DIRECTION_HORIZONTAL';
export default DIRECTION_HORIZONTAL;